import moment from "moment";
import { IBulkUploadAppointments, ITextInput } from "../../helpers/Interfaces";
import DocumentButton from "../DocumentButton/DocumentButton";
import InputDropDown from "../InputDropDown/InputDropDown";
import Stepper from "../Stepper/Stepper"

import "./BulkUploadAppointments.scss";

type UploadProps = {
    loading: boolean;
    setLoading: CallableFunction;
    clinics: ITextInput[];
    setSelectedClinic: CallableFunction;
    appointments: IBulkUploadAppointments[];
    back: CallableFunction;
    next: CallableFunction;
    count: { total: number, valid: number, invalid: number }
}

export default function Upload(props: UploadProps) {
    function getAppointmentDateTime(dateOfAssessment?: Date, startTime?: Date, endTime?: Date) {
        const formattedDate = moment(dateOfAssessment).format("DD-MM-YYYY");

        const formattedStart = moment(startTime).format("hh:mm A");
        const formattedEnd = moment(endTime).format("hh:mm A");

        return `${formattedDate} @ ${formattedStart} - ${formattedEnd}`;
    }

    function getRecordCount() {
        const totalCount = props.count.total;
        const valid = props.count.valid;
        const invalid = props.count.invalid;

        if (totalCount > 1 || totalCount === 0) {
            return `Total ${totalCount} Records. ${valid} Loaded ${invalid} Invalidated`;
        }

        return `Total ${totalCount} Record. ${valid} Loaded ${invalid} Invalidated`
    }

    return (
        <div className="verify">
            <div className="stepper">
                <Stepper steps={[
                    { circleStyle: "inactive", descriptionStyle: "description-inactive", description: "Select File" },
                    { circleStyle: "active", descriptionStyle: "description-active", description: "Upload" }
                ]} />
            </div>
            <div className="data-wrapper">
                <div className="input-records-wrapper">
                    <div className="input">
                        <InputDropDown type="search" title={"CLINIC*"} values={props.clinics} typeable={false}
                            onSelect={(value: any) => {
                                if (value?.length > 0) {
                                    props.setSelectedClinic(value[0].value);
                                }
                            }} />
                    </div>
                    <div className="records">{getRecordCount()}</div>
                </div>
                <div className="appointments-wrapper">
                    {props.appointments.map((appointment) => {
                        return (
                            <div className="data">
                                <div className="row">
                                    <span className="title">Patient Name:</span>
                                    <span className="info">{appointment.patientName}</span>
                                </div>
                                <div className="row">
                                    <span className="title">Appointment:</span>
                                    <span className="info">{getAppointmentDateTime(appointment.dateOfAssessment, appointment.startTime,
                                        appointment.endTime)}
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="footer-btn">
                <div className='next-button-content'>
                    <span onClick={() => { props.back() }} className="back">Back</span>
                    <div className="button">
                        <DocumentButton loading={props.loading} onClick={() => { props.next() }} text={"Upload"} />
                    </div>
                </div>
            </div>
        </div>
    )
}